export const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
  >
    <path
      d="M18 0.0413437C18.5272 0.0413437 19.0047 0.254201 19.3512 0.598664L18 0.999677L17.2663 0.186778C17.4923 0.0930658 17.7401 0.0413437 18 0.0413437Z"
      fill="currentColor"
    />
    <path
      d="M17.2663 0.186778L18 0.999677L19.356 0.603421L27.022 8.26939C27.7705 9.01789 27.7705 10.2315 27.022 10.98C26.2734 11.7285 25.0599 11.7285 24.3114 10.98L19.9167 6.58525V23.0413C19.9167 24.0999 19.0585 24.958 18 24.958C16.9415 24.958 16.0833 24.0999 16.0833 23.0413V6.58525L11.6886 10.98C10.9401 11.7285 9.72655 11.7285 8.97805 10.98C8.22954 10.2315 8.22954 9.01789 8.97805 8.26939L16.6447 0.602722C16.8285 0.418959 17.0403 0.280311 17.2663 0.186778Z"
      fill="currentColor"
    />
    <path
      d="M4.58333 19.208C4.58333 18.1495 3.72521 17.2913 2.66667 17.2913C1.60812 17.2913 0.75 18.1495 0.75 19.208V30.708C0.75 33.8836 3.32436 36.458 6.5 36.458H29.5C32.6756 36.458 35.25 33.8836 35.25 30.708V19.208C35.25 18.1495 34.3919 17.2913 33.3333 17.2913C32.2748 17.2913 31.4167 18.1495 31.4167 19.208V30.708C31.4167 31.7666 30.5585 32.6247 29.5 32.6247H6.5C5.44145 32.6247 4.58333 31.7666 4.58333 30.708V19.208Z"
      fill="currentColor"
    />
  </svg>
);
